import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoriesSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  return (
    <section id="categories" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{t("categories.title")}</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl mx-auto">{t("categories.subtitle")}</p>
        </div>

        {/* Dropdown */}
        <div className="relative max-w-md mx-auto mb-10" ref={dropdownRef}>
          <button
            onClick={() => setOpen((v) => !v)}
            className="w-full flex items-center justify-between px-5 py-3.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-800 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-menu-line text-sm text-foreground-500"></i>
              {t("categories.dropdownLabel")}
            </span>
            <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${open ? "rotate-180" : ""}`}></i>
          </button>

          {open && (
            <div className="absolute z-20 left-0 right-0 mt-2 max-h-72 overflow-y-auto rounded-lg border border-background-200 bg-background-50 shadow-lg py-1.5">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between px-5 py-2.5 text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
                >
                  <span>{t(`categories.${cat.id}`)}</span>
                  <i className="ri-arrow-right-up-line text-foreground-400"></i>
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Category buttons grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-background-100 transition-colors overflow-hidden"
            >
              <div className="w-full aspect-square overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex items-center justify-center gap-1.5 px-2 py-3">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors leading-tight text-center">
                  {t(`categories.${cat.id}`)}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 transition-colors text-sm"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}